import { DeploymentStatus, PolicyDeploymentStatus, StackStatus } from '@/types'

const deploymentStatusMessage: { [key in DeploymentStatus]: string } = {
  IN_PROGRESS: 'Deployment in progress',
  FINISHED: 'Successful deployment.',
  ROLLBACK_COMPLETE: 'Rollback completed. Keeping previous version.',
  ROLL_BACK: 'Rollback in progress.',
  PREDEPLOYMENT_FAILURE: 'Tests failed.',
  NOT_DEPLOYED: 'Not deployed.',
  NON_EXISTING_STACK: 'Not deployed.',
  DEPLOYMENT_FAILURE: 'Deployment failed.',
  NEW_DEPLOYMENT_BUILD_FAILED: 'New build for the policy failed. Keeping the previous version.',
}

const stackStatusMessage: { [key in StackStatus]: string } = {
  CREATE_COMPLETE: 'Successful deployment.',
  CREATE_IN_PROGRESS: 'Deployment in progress.',
  CREATE_FAILED: 'Deployment failed.',
  DELETE_COMPLETE: 'Stack deleted.',
  DELETE_IN_PROGRESS: 'Deleting stack.',
  DELETE_FAILED: "Stack's deletion failed.",
  REVIEW_IN_PROGRESS: 'Deployment in progress.',
  ROLLBACK_COMPLETE: 'Deployment failed and stack deleted.',
  ROLLBACK_FAILED: 'Deployment failed and stack not deleted.',
  ROLLBACK_IN_PROGRESS: 'Rollback in progress.',
  UPDATE_COMPLETE: 'Successful deployment.',
  UPDATE_COMPLETE_CLEANUP_IN_PROGRESS: 'Successful deployment.',
  UPDATE_IN_PROGRESS: 'Re-deployment in progress.',
  UPDATE_ROLLBACK_COMPLETE: 'Stack update failed. Successful return to previous working state.',
  UPDATE_ROLLBACK_FAILED: 'Stack update failed. Contact Iris team.',
  UPDATE_ROLLBACK_IN_PROGRESS: 'Rollback in progress.',
  UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS: 'Re-deployment failed.',
  IMPORT_IN_PROGRESS: 'Import operation in progress.',
  IMPORT_COMPLETE: 'Import operation successfully completed.',
  IMPORT_ROLLBACK_IN_PROGRESS: 'Import roll back in progress.',
  IMPORT_ROLLBACK_FAILED: 'Import rollback operation failed',
  IMPORT_ROLLBACK_COMPLETE: 'Import successfully rolled back to the previous configuration',
  NON_EXISTING_STACK: 'Not deployed.',
  NEW_DEPLOYMENT_BUILD_FAILED: 'New build for the policy failed. Keeping the previous version.',
  UNKNOWN: 'Unknown.',
}

/**
 * Returns human friendly message about policy deployment state.
 * Falls back on the messages based on stack status if deployment_status doesn't exist
 */
export const getDeploymentMessage = (deployment: PolicyDeploymentStatus) => {
  const deploymentStatus = deployment.deployment_status
  const stackStatus = deployment.status

  if (deploymentStatus) {
    const message = deploymentStatusMessage[deploymentStatus]

    if (!message) {
      return `Unknown status ${deploymentStatus}`
    }

    return message
  }

  return stackStatusMessage[stackStatus]
}

export const getRegionNameFromUrl = (url: string) => {
  const match = url.match(/execute-api.(.*).amazonaws/)
  if (!match) return undefined
  return match.pop()
}
